import { User } from "./entities";

export class Rating {
  readonly id: number;
  public stars: number;
  public message: string;
  readonly likes: UserLikes[];
  readonly userName: string;
  readonly userImage: string;
  readonly userID: number;
  readonly createdAt: string;

  constructor(stars: number, message: string) {
    this.id = 0;
    this.stars = stars;
    this.message = message;
    this.likes = [];
    this.userName = "";
    this.userImage = "";
    this.createdAt = "";
    this.userID = 0;
  }
}

export class UserLikes {
  userID: number;
  userName: string;
  userImage: string;

  constructor(userID = 0, userName = "", userImage = "") {
    this.userID = userID;
    this.userName = userName;
    this.userImage = userImage;
  }
}

export class RatingList {
  public ratings: Rating[];
  public haveRatings: boolean;

  constructor(ratings = [], haveRatings = false) {
    this.ratings = ratings;
    this.haveRatings = haveRatings;
  }
}
